import _Object$keys from 'babel-runtime/core-js/object/keys';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$assign from 'babel-runtime/core-js/object/assign';

/* eslint-disable max-lines */
import { getTagList } from '@/api/common/index.js';
import { updateMaterialInfo } from '@/api/res_store/update';
import { getMaterialInfo } from '@/api/res_store/info';
import { createMaterial } from '@/api/res_store/create';
import { contrastObj } from '@/utils/index';
import * as api from '@/config/api';
import { v2Host } from '@/config/host';

export default {
  data: function data() {
    var checkLength = function checkLength(rule, value, callback) {
      if (value.length > 50) {
        return callback(new Error('风格描述标签数量不能超过50'));
      }
      return callback();
    };
    var checkALength = function checkALength(rule, value, callback) {
      if (value.length > 50) {
        return callback(new Error('动作描述标签数量不能超过50'));
      }
      return callback();
    };
    return {
      bLoading: false,
      oInfo: {},
      ext_config: {},
      oStyle: {
        bLoading: true,
        aList: [],
        bIptVisible: false,
        sIptVal: ''
      },
      oAnimation: {
        bLoading: true,
        aList: [],
        bIptVisible: false,
        sIptVal: ''
      },
      oType: {
        bLoading: true,
        aList: []
      },
      aFileList: [],
      aIconList: [],
      oData: {
        name: '',
        tag1_names: [],
        tag2_names: [],
        file_path: '',
        img_file: '',
        ext_config: {},
        skin: '', // ext_config
        biological: '', // ext_config
        biological_type: '', // ext_config
        image_origin_name: '',
        file_origin_name: ''
      },
      oRule: {
        name: [{ required: true, message: '请填写模型名称', trigger: 'change' }],
        tag1_names: [{ required: true, message: '请选择风格', trigger: 'change' }, { validator: checkLength, trigger: 'change' }],
        tag2_names: [{ required: true, message: '请选择动作', trigger: 'change' }, { validator: checkALength, trigger: 'change' }],
        img_file: [{ required: true, message: '请上传预览图片', trigger: 'change' }],
        file_path: [{ required: true, message: '请上传模型文件', trigger: 'change' }]
      }
    };
  },

  computed: {
    uploadUrl: {
      get: function get() {
        return v2Host + '/upload/file';
      }
    },
    downloadUrl: {
      get: function get() {
        return api.resStoreDownloadUrl;
      }
    }
  },
  mounted: function mounted() {
    this.fnGetStyle();
    this.fnGetAnimation();
    this.fnGetType();
    if (this.$route.params.id) {
      this.fnGetInfo();
    }
  },

  methods: {
    // 获取单个详情
    fnGetInfo: function fnGetInfo() {
      var _this = this;

      this.bLoading = true;
      getMaterialInfo({
        id: this.$route.params.id
      }).then(function (res) {
        _this.oInfo = res.data.data.info;
        _this.oInfo.ext_config = JSON.parse(_this.oInfo.ext_config);
        _this.bLoading = false;
        _this.oData.name = _this.oInfo.name;
        _this.oData.tag1_names = _this.oInfo.tag1_list.map(function (e) {
          return e.name;
        });
        _this.oData.tag2_names = _this.oInfo.tag2_list.map(function (e) {
          return e.name;
        });
        _this.oData.file_path = _this.oInfo.file_url;
        _this.oData.img_file = _this.oInfo.image_url;
        _this.oData.image_origin_name = _this.oInfo.image_origin_name;
        _this.oData.file_origin_name = _this.oInfo.file_origin_name;
        // ext_config
        _this.oData.skin = _this.oInfo.ext_config.skin;
        _this.oData.biological = _this.oInfo.ext_config.biological;
        _this.oData.biological_type = _this.oInfo.ext_config.biological_type;
        _this.aFileList = [{
          url: _this.oInfo.file_url,
          name: _this.oInfo.file_origin_name
        }];
        _this.aIconList = [{
          url: _this.oInfo.image_url,
          name: _this.oInfo.image_origin_name
        }];
        var self = _this;
        setTimeout(function () {
          if (self.$refs.form) {
            self.$refs.form.clearValidate();
          }
        }, 100);
        var sName = _this.oInfo.name.length > 20 ? _this.oInfo.name.substr(0, 20) + '...' : _this.oInfo.name;
        document.querySelector('.app-breadcrumb .u-breadcrumb-cur').innerHTML = '编辑：' + sName;
      }).catch(function () {
        _this.bLoading = false;
      });
    },

    // 获取风格
    fnGetStyle: function fnGetStyle() {
      var _this2 = this;

      this.oStyle.bLoading = true;
      getTagList({
        type: 3
      }).then(function (res) {
        _this2.oStyle.bLoading = false;
        _this2.oStyle.aList = res.data.data.tags;
      }).catch(function () {});
    },

    // 获取动作
    fnGetAnimation: function fnGetAnimation() {
      var _this3 = this;

      this.oAnimation.bLoading = true;
      getTagList({
        type: 2
      }).then(function (res) {
        _this3.oAnimation.bLoading = false;
        _this3.oAnimation.aList = res.data.data.tags;
      }).catch(function () {});
    },

    // 获取生物类型
    fnGetType: function fnGetType() {
      var _this4 = this;

      this.oType.bLoading = true;
      getTagList({
        type: 4
      }).then(function (res) {
        _this4.oType.bLoading = false;
        _this4.oType.aList = res.data.data.tags;
      }).catch(function () {});
    },

    // 点击新增标签
    fnShowStyleTag: function fnShowStyleTag() {
      var _this5 = this;

      this.oStyle.bIptVisible = true;
      this.$nextTick(function (_) {
        _this5.$refs.styleIpt.$refs.input.focus();
      });
    },
    fnRemoveFile: function fnRemoveFile() {
      this.oData.file_path = '';
    },
    fnRemoveIcon: function fnRemoveIcon() {
      this.oData.img_file = '';
    },
    fnShowAnimationTag: function fnShowAnimationTag() {
      var _this6 = this;

      this.oAnimation.bIptVisible = true;
      this.$nextTick(function (_) {
        _this6.$refs.animationIpt.$refs.input.focus();
      });
    },

    // 保存标签
    fnStyleSaveTag: function fnStyleSaveTag() {
      var sVal = this.oStyle.sIptVal.trim();
      if (sVal) {
        if (this.oData.tag1_names.indexOf(sVal) === -1) {
          var aStyle = this.oStyle.aList.map(function (e) {
            return e.name;
          });
          if (aStyle.indexOf(sVal) !== -1) {
            this.$message({
              message: '添加失败，标签已存在',
              type: 'warning'
            });
            this.oStyle.aList.forEach(function (e) {
              if (String(e.name) === String(sVal)) {
                e.class = 's-warn';
              }
            });
          } else {
            this.oData.tag1_names.push(sVal);
          }
        } else {
          this.$message({
            message: '已经存在该标签',
            type: 'warning'
          });
        }
      }
      this.oStyle.bIptVisible = false;
      this.oStyle.sIptVal = '';
    },
    fnAnimationSaveTag: function fnAnimationSaveTag() {
      var sVal = this.oAnimation.sIptVal.trim();
      if (sVal) {
        if (this.oData.tag2_names.indexOf(sVal) === -1) {
          var aStyle = this.oAnimation.aList.map(function (e) {
            return e.name;
          });
          if (aStyle.indexOf(sVal) !== -1) {
            this.$message({
              message: '添加失败，标签已存在',
              type: 'warning'
            });
            this.oAnimation.aList.forEach(function (e) {
              if (String(e.name) === String(sVal)) {
                e.class = 's-warn';
              }
            });
          } else {
            this.oData.tag2_names.push(sVal);
          }
        } else {
          this.$message({
            message: '已经存在该标签',
            type: 'warning'
          });
        }
      }
      this.oAnimation.bIptVisible = false;
      this.oAnimation.sIptVal = '';
    },

    // 删除标签
    fnCloseStyleTag: function fnCloseStyleTag(tag) {
      this.oData.tag1_names.splice(this.oData.tag1_names.indexOf(tag), 1);
    },
    fnCloseAnimationTag: function fnCloseAnimationTag(tag) {
      this.oData.tag2_names.splice(this.oData.tag2_names.indexOf(tag), 1);
    },
    fnChangeFile: function fnChangeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    // 上传模型文件
    fnSuccessFile: function fnSuccessFile(response, file, fileList) {
      var _this7 = this;

      if (response.code === 0) {
        this.oData.file_path = response.data.file_path;
        this.oData.file_origin_name = response.data.origin_name;
        this.$refs.form.validateField('file_path');
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this7.oData.icon_file = '';
          _this7.aFileList = [];
        });
      }
    },
    fnSuccessIcon: function fnSuccessIcon(response, file, fileList) {
      var _this8 = this;

      if (response.code === 0) {
        this.oData.img_file = response.data.file_path;
        this.oData.image_origin_name = response.data.origin_name;
        this.$refs.form.validateField('img_file');
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this8.oData.img_file = '';
          _this8.aIconList = [];
        });
      }
    },
    fnClickList: function fnClickList(file) {
      if (file.response && file.response.data && file.response.data.url) {
        window.open(file.response.data.url);
      } else {
        window.open(file.url);
      }
    },
    getPostData: function getPostData() {
      var oData = void 0,
          oInfo = void 0;
      oData = _Object$assign({}, this.oData);
      // 组装ext_config数据
      oData.ext_config.skin = oData.skin;
      oData.ext_config.biological = oData.biological;
      if (Number(oData.ext_config.biological) === 0) {
        oData.ext_config.biological_type = 0;
      } else {
        oData.ext_config.biological_type = oData.biological_type;
      }
      delete oData.skin;
      delete oData.biological;
      delete oData.biological_type;

      if (this.$route.params.id) {
        oInfo = _Object$assign({}, this.oInfo);
        oInfo.tag1_names = oInfo.tag1_list.map(function (e) {
          return e.name;
        });
        oInfo.tag2_names = oInfo.tag2_list.map(function (e) {
          return e.name;
        });
        oInfo.img_file = oInfo.image_url;
        oInfo.file_path = oInfo.file_url;
        // if (+oData.ext_config.biological === 0) {
        //   delete oData.ext_config.biological_type
        // }
        // if (+oInfo.ext_config.biological === 0) {
        //   delete oInfo.ext_config.biological_type
        // }
        oData.ext_config = _JSON$stringify(oData.ext_config);
        oInfo.ext_config = _JSON$stringify(oInfo.ext_config);
        oData = contrastObj(oData, oInfo);
        if (_Object$keys(oData).length === 0) {
          this.$message({
            message: '没有任何修改',
            type: 'warning'
          });
          this.bLoading = false;
          return {};
        }
        if (oData.file_path) {
          oData.file_type = 'local';
          oData.file_origin_name = this.oData.file_origin_name;
        }
        oData.queryId = this.$route.params.id;
        oData.tag1_names && (oData.tag1_names = oData.tag1_names.join());
        oData.tag2_names && (oData.tag2_names = oData.tag2_names.join());
      } else {
        oData.res_type = 1;
        oData.file_type = 'local';
        oData.tag1_names = oData.tag1_names.join();
        oData.tag2_names = oData.tag2_names.join();

        // if (+oData.ext_config.biological !== 1) {
        //   delete oData.ext_config.biological_type
        // }
        oData.ext_config = _JSON$stringify(oData.ext_config);
      }

      return oData;
    },
    fnOnUploadError: function fnOnUploadError() {
      this.$message.warning('文件上传出错！');
    },
    fnSubmit: function fnSubmit() {
      var _this9 = this;

      var self = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this9.bLoading = true;
          var submitPromist = '';
          submitPromist = _this9.$route.params.id ? updateMaterialInfo : createMaterial;
          submitPromist(_this9.getPostData()).then(function (res) {
            self.bLoading = false;
            self.$message({
              message: 'success',
              type: 'success'
            });
            if (_this9.$route.params.id) {
              setTimeout(function () {
                if (location.href.indexOf('edit') !== -1 || location.href.indexOf('add') !== -1) {
                  self.$router.back(-1);
                }
              }, 3000);
            } else {
              setTimeout(function () {
                if (location.href.indexOf('edit') !== -1 || location.href.indexOf('add') !== -1) {
                  self.$router.push({ name: 'repo.itav-material.model-list' });
                }
              }, 3000);
            }
          }).catch(function () {
            _this9.bLoading = false;
          });
        }
      });
    },
    fnBackBtn: function fnBackBtn() {
      var _this10 = this;

      var h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [h('p', null, '\u786E\u8BA4\u8FD4\u56DE\uFF1F\u82E5\u7EE7\u7EED\uFF0C\u5F53\u524D\u5DF2\u586B\u5199\u7684\u5185\u5BB9\u5747\u4F1A\u4E22\u5931\u3002')]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            _this10.$router.back(-1);
          }
          done();
        }
      }).then(function (action) {});
    }
  }
};